import React, { useState, useEffect } from 'react';


function MultiplayerWaitingRoom({ onGameStart, onCancel, socket }) {
  const [message, setMessage] = useState('Connecting to multiplayer...');
  const [username, setUsername] = useState('');
  const [state, setState] = useState('waitingRoom'); // Track backend state
  const [initialQuestion, setInitialQuestion] = useState(null);

  useEffect(() => {
    const newSocket = socket;

    newSocket.on('connect', () => {
      console.log('Connected to multiplayer server', newSocket.id);
    });

    newSocket.on('waiting', (data) => {
      setState('waitingRoom');
      setMessage(data.message);
    });

    newSocket.on('startingGame', (data) => {
        setState('startingGame');
        setMessage(`Opponent found: ${data.opponent.username}. Starting the game...`);
        onGameStart(username, data.opponent.username);
       // setTimeout(() => {
       //   onGameStart(username, data.opponent.username);
       //}, 3000); // Matches backend delay
    });

    newSocket.on('inProgress', (data) => {
      setState('inProgress');
      setMessage('Game in progress...');
      console.log("inProgress data", data);
      setInitialQuestion(data.game.question);
      // Handle additional game updates here if needed
    });

    newSocket.on('timeout', (data) => {
      setState('waitingRoom');
      setMessage(data.message);
    });

    newSocket.on('error', (data) => {
      setState('error');
      setMessage(data.message);
    });

    return () => {
      newSocket.off('connect');
      newSocket.off('waiting');
      newSocket.off('startingGame');
      newSocket.off('inProgress');
      newSocket.off('timeout');
      newSocket.off('error');
    };
  }, [socket, onGameStart, username]); // Add dependencies to avoid stale state

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handleStartGame = () => {
    if (username && socket) {
      socket.emit('joinMultiplayer', { username });
    } else {
      alert('Please enter a username!');
    }
  };

  return (
    <div className="waiting-room">
      <h2>Multiplayer</h2>
      <p>{message}</p>
      {state === 'waitingRoom' && (
        <div>
          <input
            type="text"
            placeholder="Enter your username"
            value={username}
            onChange={handleUsernameChange}
            maxLength={15}
          />
          <button onClick={handleStartGame}>Start Multiplayer</button>
        </div>
      )}
      {state === 'startingGame' && <p>Preparing your game...</p>}
      <button onClick={onCancel}>Cancel</button>
    </div>
  );
}

export default MultiplayerWaitingRoom;
